import { withInstallFunction } from '@bigin/utils'

import Message from './src/method'

export const BMessage = withInstallFunction(Message, '$message')
export default BMessage

export * from './src/message'
